module.exports = __webpack_public_path__ + "img/002b8a4b4e0821f28ae15b7ef30f11f6deddfc35.7637ad8b.jpg";